const home = {
  heroAlt: "Professionals reviewing plans on a renovation site",
  galleryAlt: "Construction and renovation sector",
  install: {
    iosSub: "Download on the",
    androidSub: "Get it on",
    iosTitle: "Install on iPhone/iPad",
    iosDesc: "Open this page in Safari, tap Share and then 'Add to Home Screen'.",
    androidTitle: "Install the app",
    androidDesc: "Open the browser menu and choose 'Install app' / 'Add to Home screen'.",
  },
  apps: {
    nuvliTitle: "NuvliPro mobile app",
    nuvliDesc: "Quotes, invoices, jobs, expenses and working-hours tracking on your phone.",
    nuvliInstall: "Download NuvliPro",
    nuvliNote: "Direct install (PWA) · works on Android and iPhone, takes up no space.",
    workerTitle: "GPS Time Clock mobile app",
    workerDesc: "For employees: clock in/out with GPS and sign in with an access code.",
    workerInstall: "Download GPS Time Clock",
    workerNote: "For workers · after installing, open the app and sign in with your access code.",
    workerCta: "Open worker app",
    qrTitle: "GPS time tracking",
    qrSubtitle: "Easy, secure clock-in for your team",
    qrText: "Download it free from our website",
    qrInstall: "Install on your phone",
    qrAvailable: "Available for Android and iPhone",
  },
  login: {
    title: "Sign in", email: "Email", password: "Password", emailPh: "you@email.com", submit: "Sign in",
    forgot: "Forgot your password?", register: "Sign up free", welcome: "Welcome", error: "Sign-in failed",
  },
  features: {
    badge: "Features",
    title: "Everything you need to run your business",
    items: [
      { t: "Invoicing", d: "Invoices with automatic numbering, VAT and income-tax withholding, statuses and professional PDF download." },
      { t: "Quotes", d: "Quotes organised by chapters and detailed line items; turn them into an invoice with one click." },
      { t: "Expense control", d: "Record materials, labour and supplies; track spending by job and category." },
      { t: "Partial payments", d: "Record payments on account, track the outstanding balance and send receipts automatically." },
      { t: "Quarterly reports", d: "VAT and income tax per quarter, ready for your accountant and exportable to PDF and Excel." },
      { t: "Client management", d: "Full profile for every client, document history and overdue-payment detection." },
    ],
  },
  pricing: {
    badge: "Plans & pricing",
    title: "Choose the plan that best fits your business",
    subtitle: "Start free with no end date. Upgrade whenever you need more: no commitment, cancel anytime.",
    freeCta: "Create free account",
    labels: { gratuito: "Free Plan", trimestral: "Quarterly Plan", anual: "Annual Plan" },
    perMonth: "{{amount}}/mo",
    approx: "≈ {{amount}}/mo",
    periodo: { gratuito: "No end date", trimestral: "{{total}} every 3 months", anual: "{{total}} per year" },
    nota: { gratuito: "Get started without paying", trimestral: "Unlimited, billed every 3 months", anual: "One payment a year" },
    badges: { trimestral: "Most popular" },
    save: "You save {{amount}}/year",
    features: {
      gratuito: ["Up to 8 clients", "Up to 8 quotes", "Invoicing and partial payments for your 8 clients", "Expenses and quarterly reports: last 2 quarters", "2 job projects", "Time tracking with unlimited workers"],
      trimestral: ["Unlimited clients, quotes and jobs", "Full expense and quarterly history", "AI, VeriFactu and bank reconciliation", "Email and WhatsApp reminders", "Export for your accountant"],
      anual: ["Everything in the Quarterly plan", "Custom documents and logo", "Scheduled automatic alerts", "Priority support"],
    },
    payCard: "Pay by card",
    payNote: "Card: automatic renewal, cancel anytime",
    footnote: "Prices exclude VAT · Card payment · Secure payment handled by Stripe",
    approxNote: "Approximate equivalent in {{currency}} at today's exchange rate. The exact amount is shown on the payment page.",
    payError: "Could not start the payment",
  },
  trust: {
    title: "Professionals who already trust NuvliPro",
    subtitle: "Real reviews from construction and renovation companies.",
    testimonials: [
      { cargo: "General Manager", empresa: "Constructora MendozaBuild S.A.", texto: "We spent more than a decade on Excel and systems that didn't talk to each other. With NuvliPro we brought together all the information on our 8 projects and cut admin time by 60%. Profitability reports per project are now accurate and I make decisions with real data, not hunches." },
      { cargo: "Project Director", empresa: "Grupo Constructor Rojas & Asociados", texto: "We went from 3 to 12 active projects and our manual system collapsed. With NuvliPro we grew without doubling our admin staff: full traceability of every material, real-time subcontractor control and 75% less final paperwork. Our clients receive reports that build trust." },
      { cargo: "Self-employed Owner", empresa: "18 years in the sector", texto: "My jobs were getting more complex and less profitable, and costs were slipping away without me knowing where. With NuvliPro I found the financial leaks, consolidated suppliers and cut overheads by 22% without sacrificing quality. Now I prepare more detailed quotes in less time and close more projects." },
    ],
    seals: [
      { t: "GDPR compliant", d: "Protected data" },
      { t: "SSL encryption", d: "Secure connection" },
      { t: "Payments with Stripe", d: "Protected payments" },
      { t: "Support in Spanish", d: "Whenever you need it" },
    ],
  },
  demo: {
    badge: "Demo video",
    title: "Discover NuvliPro in 2 minutes",
    subtitle: "See how to create a quote, turn it into an invoice and keep track of payments and expenses.",
    unsupported: "Your browser does not support video playback.",
    soon: "Demo video coming soon",
  },
  faq: {
    badge: "FAQ",
    title: "We answer your questions",
    items: [
      { q: "Do I need accounting knowledge to use NuvliPro?", a: "No. NuvliPro is designed for self-employed professionals and small businesses: you create quotes and invoices by filling in clear fields, and the app automatically calculates VAT, income-tax withholding and totals." },
      { q: "Can I try it for free?", a: "Yes. The Free Plan never expires and needs no card: up to 8 clients, 8 quotes, 8 invoices and 1 active job project. When you need more, upgrade to a paid plan." },
      { q: "Is my clients' data secure?", a: "Yes. We encrypt the connection (SSL), we comply with the GDPR and payments are handled securely by Stripe. We never share your data." },
      { q: "Can I customise my invoices and quotes with my logo?", a: "Yes. From your Personal Area you can upload your company logo and choose the document design so it reflects your brand." },
      { q: "Does NuvliPro help with quarterly tax control?", a: "Yes. It automatically generates the summary of output/input VAT and income tax per quarter, exportable to PDF and Excel for your accountant." },
      { q: "Can I cancel whenever I want?", a: "Of course. There is no commitment: you can change or cancel your plan at any time from your account." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "Shall we talk?",
    subtitle: "Tell us what you need and we'll get back to you as soon as possible. We're here to help you get the most out of NuvliPro.",
    support: "Customer service",
    supportNote: "Support in Spanish · reply within 24-48 h",
    name: "Name", namePh: "Your name", email: "Email", emailPh: "you@email.com",
    message: "Message", messagePh: "How can we help you?", send: "Send message",
    sent: "Message sent! We'll get back to you soon.", error: "The message could not be sent",
  },
  cta: {
    title: "Your whole business, in one place",
    items: ["Clients", "Quotes", "Invoicing", "Partial payments", "Expenses", "Quarterly", "Overdue payments", "WhatsApp"],
    button: "Create my free account",
  },
  footer: "All-in-one management for construction and renovation professionals",
};
export default home;
